import axios from 'axios';

class HttpCommons {
  constructor(guid) {
    this.guid = guid
    this.axios = axios
    this.baseUrl = process.env.VUE_APP_API_URL + 'web/' + `landingpageimmobili%28key=${this.guid}%29`
    this.HTTP = axios.create({
      baseURL: this.baseUrl,
    })
    this.TESTHTTP = axios.create({
      baseURL: process.env.VUE_APP_API_URL + 'web/' + `landingpageimmobili`
    })
  }

  attachmentSrc(id) {
    return `${this.baseUrl}/Allegato%28idpubblico=${id},thumb=false%29`
  }

  videoSrc(id) {
    return `/Allegato%28idpubblico=${id},thumb=false%29`
  }

  energeticClassImage() {
    return process.env.VUE_APP_API_URL + 'ClasseEnergeticaImageURL%28id=' + this.guid + '%29'
  }
}

const arrayBufferToBase64 = buffer => {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

/*const fetchThumbnail = (id, type='thumbnail') => {
    const url =
        type === 'thumbnail' ?
            `Immobili(${id})/Anteprima(thumb=false)` :
            `Allegato(key=${id},thumb=false)`
  return new Promise ((resolve, reject) => {
    HTTP.get(url, {
      responseType: "arraybuffer"
    })
      .then(resp => {
        if (arrayBufferToBase64(resp.data)) {
          resolve({
            src: arrayBufferToBase64(resp.data),
            loading: false
          })
        }
      })
      .catch(e => {
        reject(e)
      });
  })
}*/

export { HttpCommons, arrayBufferToBase64 }
